import useComputed from '@/hooks/use-computed'
import api from '@/services/api/dataDictionary'
import { useFeature } from '@/hooks/use-feature'
import { featureConstant } from '@/constants/configuration/feature.js'
import { useState } from 'react'
import { orderBy, uniqBy } from 'lodash'

export function serialize(entry) {
    return {
        dataElementId: entry.dataElementId,
        classification: entry.classification,
        dataElementName: entry.dataElementName,
        description: entry.description,
        fields: entry.fields,
        useCase: orderBy(entry.useCase, ["useCaseName"], ['asc'])
    }
}

export function serializeClassifications(entry) {
    let name = "All (Default)";
    let value = "ALL";
    if (entry === "DOCUMENT") {
        name = "Document"
        value = "DOCUMENT"
    }
    if (entry === "EVENT") {
        name = "Event"
        value = "EVENT"
    }

    return {
        name,
        value
    }
}

export function serializeUseCasesLists(entry) {
    return {
        id: entry.useCaseId,
        label: entry.useCaseName,
        value: entry.useCaseId,
        $selected: true
    }
}

export function setInitialDataForFields(classificationsList, response, setClassificationsLists, setUseCasesLists) {
    if (classificationsList.length === 0) {
        response.items.dataElementClassification = ["ALL (Default)", ...response.items.dataElementClassification]
        // Unknown entries (e.g. an "ALL" sent by the API) serialize to the same "ALL"
        // option as the one prepended above, so keep only the first of each value.
        const classifications = response.items.dataElementClassification.map(entry => serializeClassifications(entry))
        setClassificationsLists(uniqBy(classifications, "value"))
        setUseCasesLists(response.items.useCases.map(entry => serializeUseCasesLists(entry)))
    }
}

const useDataDictionary = () => {

    const [error, setError] = useState()
    const [loading, setLoading] = useState(false)
    const [items, setItems] = useComputed([])
    const [allData, setAllData] = useState();
    const [dataElementDetails, setDataElementDetails] = useComputed([])
    const [useCasesLists, setUseCasesLists] = useState([])
    const [classificationsList, setClassificationsLists] = useState([])
    const isDSVEnabled = useFeature(featureConstant.DSV_ENABLED)

    async function fetchDataDictionaryLists(params) {
		setLoading(true)
        const [err, response] = await api.index(params, isDSVEnabled);
		setLoading(false)
        if (err) {
            return setError(err);
        }
        setAllData(response.meta);
        setItems(response.items.data.map(entry => serialize(entry)))
        setInitialDataForFields(classificationsList, response, setClassificationsLists, setUseCasesLists)
    }

    async function fetchDataDictionaryDetails(params) {
        setLoading(true)
        const [err, response] = await api.indexDetails(params, isDSVEnabled);
        setLoading(false)
        if (err) {
            return setError(err);
        }
        setDataElementDetails(response)
        return response.fields
    }

    return {
        error,
        fetchDataDictionaryLists,
        fetchDataDictionaryDetails,
        loading,
		setLoading,
        items,
        allData,
        dataElementDetails,
        setDataElementDetails,
        useCasesLists,
        classificationsList
    }

}

export default useDataDictionary
